<!--
  name : 김혜진
  desc : header-멤버용
  date : 2020-12-08
-->
<template>
  <!--상태:로그인-->
  <v-row
    no-gutters
    align="center"
    justify="center"
    id="top_bar"
    v-if="getName()"
  >
    <v-navigation-drawer
      id="navD"
      v-if="responsive"
      v-model="drawer"
      left
      temporary
      fixed
      mobile-break-point="960"
    >
      <v-list class="navD_M_list">
        <v-menu offset-x>
          <template v-slot:activator="{ on, attrs }">
            <v-col cols="auto" class="top_bar_user" v-bind="attrs" v-on="on">
              <v-list-item>
                <v-list-item-avatar
                  left
                  class="user_pic_s cpn"
                  v-if="getOrgname()"
                >
                  <v-img :src="UserImgUrl"></v-img>
                </v-list-item-avatar>
                <v-list-item-avatar left class="user_pic_s" v-else>
                  <v-img :src="UserImgUrl"></v-img>
                </v-list-item-avatar>
                <v-list-item-title class="user_s_tt_company" v-if="getOrgname()"
                  >{{ getOrgname() }}({{
                    getOrgreg() | regNumFilter
                  }})</v-list-item-title
                >
                <v-list-item-subtitle class="user_s_tt_name"
                  >{{ getName() }} 님</v-list-item-subtitle
                >
              </v-list-item>
              <span class="icon"></span>
            </v-col>
          </template>
          <orgTopList ref="orgTopList" :userName="userName"></orgTopList>
        </v-menu>
      </v-list>

      <v-list class="navD_M_list">
        <ul class="menu_nav">
          <li v-for="(menu, i) in mainMenus" :key="i" :class="menu.id">
            <v-list-item
              link
              text
              :to="menu.to"
              @click="onClickMenu($event, menu)"
            >
              <v-list-item-icon class="navI"> </v-list-item-icon>
              <v-list-item-title>{{ menu.text }}</v-list-item-title>
            </v-list-item>
          </li>
          <li class="cpncontract">
            <v-list class="subM00">
              <v-list-group
                v-for="item in items"
                :key="item.title"
                v-model="item.active"
                :prepend-icon="item.action"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item>
                    <v-list-item-icon class="navI menu_cpnWrite">
                    </v-list-item-icon>
                    <v-list-item-title>사내계약</v-list-item-title>
                  </v-list-item>
                </template>
                <v-list class="mt-2">
                  <v-list-item
                    @click="goCreateOfficeContract()"
                    class="subM01"
                    v-if="getOrgname()"
                  >
                    <v-list-item-title>사내계약 작성</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="goOfficeContractList()" class="subM01">
                    <v-list-item-title>사내계약 조회</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-list-group>
            </v-list>
          </li>
          <li class="setting">
            <v-list class="subM00 ">
              <v-list-group
                v-for="item in items1"
                :key="item.title"
                v-model="item.active"
                :prepend-icon="item.action"
                no-action
              >
                <template v-slot:activator>
                  <v-list-item>
                    <v-list-item-icon class="navI"> </v-list-item-icon>
                    <v-list-item-title>설정</v-list-item-title>
                  </v-list-item>
                </template>
                <v-list class="mt-2">
                  <v-list-item @click="goOrgConfig()" class="subM01">
                    <v-list-item-title>사용자 설정</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="goContract()" class="subM01">
                    <v-list-item-title>계약 정보 설정</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="goChain()" class="subM01">
                    <v-list-item-title>블록 체인 관리</v-list-item-title>
                  </v-list-item>
                  <v-list-item link @click="goVerify()" class="subM01">
                    <v-list-item-title>계약 파일 검증</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="goDepartment()"  class="subM01">
                      <v-list-item-title>부서 관리</v-list-item-title>
                    </v-list-item> -->
                  <v-list-item @click="goCrew()" class="subM01">
                    <v-list-item-title>사원 관리</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-list-group>
            </v-list>
          </li>
        </ul>
      </v-list>
      <v-divider></v-divider>
      <v-list dense nav class="py-0">
        <v-list-item v-for="item in items" :key="item.title" link>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar-nav-icon
      dark
      class="top_bar_mM"
      @click.stop="drawer = !drawer"
    ></v-app-bar-nav-icon>
    <v-toolbar-title class="top_bar_logo" @click="goMain">로고</v-toolbar-title>
    <v-row no-gutters class="top_bar_pc justfy-end align-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-col cols="auto" class="top_bar_user" v-bind="attrs" v-on="on">
            <v-list-item>
              <v-list-item-avatar
                left
                class="user_pic_s cpn"
                v-if="getOrgname()"
              >
                <v-img :src="UserImgUrl" style="height: 100%"></v-img>
              </v-list-item-avatar>
              <v-list-item-avatar left class="user_pic_s" v-else>
                <v-img :src="UserImgUrl" style="height: 100%"></v-img>
              </v-list-item-avatar>
              <v-list-item-title class="user_s_tt_company" v-if="getOrgname()"
                >{{ getOrgname() }}({{
                  getOrgreg() | regNumFilter
                }})</v-list-item-title
              >
              <v-list-item-subtitle class="user_s_tt_name">{{
                getName()
              }}</v-list-item-subtitle
              >님
            </v-list-item>
            <span class="icon"></span>
          </v-col>
        </template>
        <orgTopList ref="orgTopList" :userName="userName"></orgTopList>
      </v-menu>
      <v-btn class="btn_top_bar00" @click="logout">로그아웃</v-btn>
    </v-row>
  </v-row>
  <!--상태:로그아웃 -->
  <v-row no-gutters align="center" justify="center" id="top_bar" v-else>
    <v-toolbar-title class="top_bar_logo" @click="goMain">로고</v-toolbar-title>
    <v-row no-gutters class="top_bar_pc justfy-end align-center">
      <v-btn class="btn_top_bar00">로그인</v-btn>
      <v-btn class="btn_top_bar00">회원가입</v-btn>
    </v-row>
  </v-row>
</template>
<script>
import orgTopList from "@/views/layout/components/orgHeaderList";
import { getUserImgList } from "@/api/userImg";
// import store from '@/store'

export default {
  name: "s-header",
  components: {
    orgTopList
  },
  filters: {
    regNumFilter: function(value) {
      if (value) {
        return String(value).replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      }
    }
  },
  data() {
    return {
      mainMenus: [],
      userName: "",
      // 모바일용 메뉴바
      drawer: null,
      // 설정 하위메뉴
      items: [
        {
          active: true
        }
      ],
      items1: [
        {
          active: true
        }
      ],
      UserImgUrl: "",
      chainAddr: ""
    };
  },
  computed: {
    responsive: {
      get() {
        return this.$store.state.actions.responsive;
      }
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.getUserImgList();
    });
    if (this.$store.state.user.orgaddr) {
      this.chainAddr = this.$store.state.user.orgaddr;
      this.activeName = "company";
    } else {
      this.chainAddr = this.$store.state.user.useraddr;
      this.activeName = "personal";
    }
    this.mainMenus = [
      { id: "menu_home", text: "대시보드", to: "/main" },
      { id: "write", text: "계약작성", to: "/write" },
      { id: "document", text: "보관함", to: "/list" },
      { id: "feepay", text: "요금정보", to: "/feepay" }
    ];
    if (this.$store.state.user.orgtmp) {
      this.mainMenus.push({ id: "auth", text: "기업인증", to: "/companyAuth" });
    }
  },
  methods: {
    // 메뉴
    getName() {
      this.userName = this.$store.state.user.username;
      return this.$store.state.user.username;
    },
    getOrgreg() {
      return this.$store.state.user.orgreg;
    },
    getOrgname() {
      return this.$store.state.user.orgname;
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        this.$router.push({ name: "main" });
        location.reload(); // 버그때문에 vue-router 인스턴스를 재시작
      });
    },
    goMain() {
      this.$router.push({ name: "main" });
    },
    goCreateOfficeContract() {
      this.$router.push("createOfficeContract");
    },
    goOfficeContractList() {
      this.$router.push("officeContractList");
    },
    goOrgConfig() {
      this.$router.push("orgConfig");
    },
    goContract() {
      this.$router.push("scontract");
    },
    goChain() {
      this.$router.push("chain");
    },
    goVerify() {
      this.$router.push("verify");
    },
    // goDepartment() {
    //   this.$router.push('department')
    // },
    goCrew() {
      this.$router.push("crew");
    },
    // 선택한 user
    getUserImgList() {
      getUserImgList(JSON.stringify({ chainAddress: this.chainAddr })).then(
        response => {
          if (response.rdata.userImg) {
            this.UserImgUrl =
              process.env.VUE_APP_URL_USER_THUMBNAIL +
              response.rdata.userImg.imgSequence;
          } else {
            this.UserImgUrl = "";
          }
        }
      );
    }
  }
};
</script>
<style scoped></style>
